export default __webpack_public_path__ + "static/media/shield.cbeec1af.svg";